import actions from './actions'

export default function Invoice2LinesReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_INVOICE2LINE:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_INVOICE2LINE:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_INVOICE2LINE:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_INVOICE2LINE:
      return {
        ...state,
        editing: { Invoice2LineID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_INVOICE2LINE_RECIEVED ||
      actions.UPDATE_INVOICE2LINE_RECIEVED ||
      actions.DELETE_INVOICE2LINE_RECIEVED:
      return {
        ...state,
        editing: { Invoice2LineID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
